import React from 'react';

import {Link, withRouter, type WithRouterProps} from 'react-router';

import {StyledCompactItemHeaderSpan} from 'app/general/bootstrap/utils';
import {getFilterLink} from 'app/general/dashboards/DashboardFilterbar';
import {gt} from 'app/utils/i18n';

import type {DashboardLocationParamsType} from 'app/documents/types';
import type {FolderHashidSerializedType} from 'sweet-types';

type OwnProps = {
  selectedFolder?: FolderHashidSerializedType;
};
type RouterProps = WithRouterProps<DashboardLocationParamsType>;
type Props = OwnProps & RouterProps;

export const GoFolderUp = withRouter<Props>(
  ({selectedFolder, router, location}: Props) => {
    const hashid =
      selectedFolder == null || selectedFolder.parent == null
        ? undefined
        : selectedFolder.parent.hashid;
    const to = getFilterLink(router, location, {
      folder: hashid,
    });
    return selectedFolder != null ? (
      <div className="row border-bottom d-flex align-items-center">
        <div className="col-12">
          <StyledCompactItemHeaderSpan>
            <Link to={to} className="py-2 d-block font-weight-bold text-dark">
              <i className="fas fa-fw fa-level-up mr-1" />
              {gt('One level up...')}
            </Link>
          </StyledCompactItemHeaderSpan>
        </div>
      </div>
    ) : null;
  }
);
